// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter-tight/500.css';
import '@fontsource/inter-tight/600.css';
import '@fontsource/inter-tight/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import './styles/globals.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import type { CurrentUser } from '@/lib/auth';

function getRootEl(): HTMLElement {
  const el = document.getElementById('root');
  if (!el) throw new Error('Missing #root element in index.html');
  return el;
}

// The local mock bar exists only under `GREENLIGHT_UI_MOCK=1`; the constant
// condition drops it from every build.
const MockBar =
  import.meta.env.VITE_GL_MOCK === '1'
    ? React.lazy(() => import('@/components/dev/MockBar').then((m) => ({ default: m.MockBar })))
    : null;

function bootstrap() {
  // The local mock answers /api/me itself, so only the unmocked dev server
  // needs a stand-in identity.
  const devUser: CurrentUser | undefined =
    import.meta.env.DEV && !MockBar
      ? { id: 'dev', email: 'dev@example.com', role: 'org_admin', groups: [] }
      : undefined;
  createRoot(getRootEl()).render(
    <React.StrictMode>
      <App initialUser={devUser} />
      {MockBar && (
        <React.Suspense fallback={null}>
          <MockBar />
        </React.Suspense>
      )}
    </React.StrictMode>,
  );
}

bootstrap();
